module.exports = __webpack_public_path__ + "img/6-on.2eaa0e17.png";